<template>
    <v-select v-model="selected" :label="label" item-text="id" :items="items" clearable color="zoezi-edit-color" />
</template>

<script>
export default {
    name: 'AnimationSetting',

    props: {
        value: {
            type: String
        },
        label: {
            type: String
        },
        entrances: {
            type: Boolean
        },
        exits: {
            type: Boolean
        },
        seekers: {
            type: Boolean
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.selected = value;
            }
        },
        selected() {
            this.$emit('input', this.selected);
        }
    },

    computed: {
        items() {
            return this.allItems.filter(x => {
                let type = x.type;
                if (!x.type) {
                    if (x.id.includes('In')) {
                        type = 'entrance';
                    } else if (x.id.includes('Out')) {
                        type = 'exit'
                    } else {
                        type = 'seeker';
                    }
                }
                if (type == 'seeker') {
                    return this.seekers;
                } else if (type == 'entrance') {
                    return this.entrances;
                } else if (type == 'exit') {
                    return this.exits;
                }
            })
        }
    },

    data: () => ({
        selected: [],
        allItems: [
            {id: 'bounce'},
            {id: 'flash'},
            {id: 'pulse'},
            {id: 'rubberBand'},
            {id: 'shakeX'},
            {id: 'shakeY'},
            {id: 'headShake'},
            {id: 'swing'},
            {id: 'tada'},
            {id: 'wobble'},
            {id: 'jello'},
            {id: 'heartBeat'},
            {id: 'backInDown'},
            {id: 'backInLeft'},
            {id: 'backInRight'},
            {id: 'backInUp'},
            {id: 'backOutDown'},
            {id: 'backOutLeft'},
            {id: 'backOutRight'},
            {id: 'backOutUp'},
            {id: 'bounceIn'},
            {id: 'bounceInDown'},
            {id: 'bounceInLeft'},
            {id: 'bounceInRight'},
            {id: 'bounceInUp'},
            {id: 'bounceOut'},
            {id: 'bounceOutDown'},
            {id: 'bounceOutLeft'},
            {id: 'bounceOutRight'},
            {id: 'bounceOutUp'},
            {id: 'fadeIn'},
            {id: 'fadeInDown'},
            {id: 'fadeInDownBig'},
            {id: 'fadeInLeft'},
            {id: 'fadeInLeftBig'},
            {id: 'fadeInRight'},
            {id: 'fadeInRightBig'},
            {id: 'fadeInUp'},
            {id: 'fadeInUpBig'},
            {id: 'fadeInTopLeft'},
            {id: 'fadeInTopRight'},
            {id: 'fadeInBottomLeft'},
            {id: 'fadeInBottomRight'},
            {id: 'fadeOut'},
            {id: 'fadeOutDown'},
            {id: 'fadeOutDownBig'},
            {id: 'fadeOutLeft'},
            {id: 'fadeOutLeftBig'},
            {id: 'fadeOutRight'},
            {id: 'fadeOutRightBig'},
            {id: 'fadeOutUp'},
            {id: 'fadeOutUpBig'},
            {id: 'fadeOutTopLeft'},
            {id: 'fadeOutTopRight'},
            {id: 'fadeOutBottomRight'},
            {id: 'fadeOutBottomLeft'},
            {id: 'flip'},
            {id: 'flipInX'},
            {id: 'flipInY'},
            {id: 'flipOutX'},
            {id: 'flipOutY'},
            {id: 'lightSpeedInRight'},
            {id: 'lightSpeedInLeft'},
            {id: 'lightSpeedOutRight'},
            {id: 'lightSpeedOutLeft'},
            {id: 'rotateIn'},
            {id: 'rotateInDownLeft'},
            {id: 'rotateInDownRight'},
            {id: 'rotateInUpLeft'},
            {id: 'rotateInUpRight'},
            {id: 'rotateOut'},
            {id: 'rotateOutDownLeft'},
            {id: 'rotateOutDownRight'},
            {id: 'rotateOutUpLeft'},
            {id: 'rotateOutUpRight'},
            {id: 'hinge'},
            {id: 'jackInTheBox', type: 'seeker'},
            {id: 'rollIn'},
            {id: 'rollOut'},
            {id: 'zoomIn'},
            {id: 'zoomInDown'},
            {id: 'zoomInLeft'},
            {id: 'zoomInRight'},
            {id: 'zoomInUp'},
            {id: 'zoomOut'},
            {id: 'zoomOutDown'},
            {id: 'zoomOutLeft'},
            {id: 'zoomOutRight'},
            {id: 'zoomOutUp'},
            {id: 'slideInDown'},
            {id: 'slideInLeft'},
            {id: 'slideInRight'},
            {id: 'slideInUp'},
            {id: 'slideOutDown'},
            {id: 'slideOutLeft'},
            {id: 'slideOutRight'},
            {id: 'slideOutUp'}
        ]
    })

}
</script>
